module.exports = __webpack_public_path__ + "static/media/text-banner-footer.8dd71ae4.png";